<template>
    <!-- TODO: ホーム画面の場合にお知らせ表示 -->
    <div
        v-show="isNavBarVisible"
        class="flex p-3 sticky top-0 left-0 right-0 bg-white z-30"
        :class="[{'justify-between' : title === 'ホーム'}]"
    >
        <icon
            v-if="!backUrl"
            :path="mdiMenu"
            class="text-[#00AF5B]"
            size="24"
            @click="menuToggleMobile()"
        />
        <router-link
            v-else
            :to="backUrl"
            :data="event"
            class="cursor-pointer"
        >
            <icon
                :path="mdiChevronLeft"
            />
        </router-link>


        <div
            v-if="title === 'ホーム'"
        >
            <img
                class="h-6"
                src="@/assets/img/spoplus_training_logo_02.png"
            >
        </div>
        <div
            v-else
            class="font-semibold ml-6"
        >
            {{ title }}
        </div>
        <div />
    </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { mdiMenu, mdiChevronLeft } from '@mdi/js'
import AsideMenuOpen from '@/assets/img/ArrowLeft.svg'
import Icon from '@/spComponents/Utilities/Icon'

export default {
    name: 'NavBar',
    components: {
        Icon
    },
    setup () {
        const store = useStore()
        const route = useRoute()
        const isNavBarVisible = computed(() => !store.state.isFullScreen)
        const backUrl = computed(() => route.meta.back)
        const isRankingPage = computed(() => route.path.includes('ranking'));
        const rankTotalingRange = computed(() => {
            return isRankingPage.value ? store.state.rankTotalingRange : ''
        })
        const title = computed(() => `${route.meta.title || ''} ${route.meta.title ? rankTotalingRange.value || '' : ''}`)
        const menuToggleMobile = () => store.dispatch('asideMobileToggle')
        return {
            AsideMenuOpen,
            isNavBarVisible,
            title,
            backUrl,
            menuToggleMobile,
            mdiMenu,
            mdiChevronLeft
        }
    }
}
</script>

<style scoped>

</style>
